export default __webpack_public_path__ + "static/media/round_glasses.c26f1bac.png";